import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../services/app.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  public menus = [];

  constructor(private app: AppService) {
    this.menus = this.app.getMenuConfig();
    this.menus.forEach((menu) => {
      menu['isCollapsed'] = false;
    });
  }

  ngOnInit() {
  }

}
